import T from "../../../common/i18n/Text";
import { PageContainer } from "../../../common/components/page-container/PageContainer";
import GameItem from "../../../common/components/game-item/GameItem";
import { GAMES } from "../../../common/utils/games";
import { usePageTitle } from "../../../common/hooks";


const GamesListPage = () => {
    usePageTitle("title.games");

    return (
        <PageContainer>
            <section className='pt-[42px]'>
                <p className='text-center pb-[46px] font-bold text-[36px] leading-[44px]'>
                    <T path="title.gamesList"/>
                </p>
                <ul>
                    {GAMES.map(game => <li key={game.name} className='mb-[36px] md:mb-[46px] last:mb-0 md:last:mb-0 hover:shadow-2xl'>
                                            <GameItem game={game} />
                                        </li>)}
                </ul>
            </section>
        </PageContainer>
    );
};

export default GamesListPage;
